import "./assets/js/polyfills";
import "./vendor";

import "./assets/js/amplitudeInit-vanilla";
import "./assets/js/functions-vanilla";
import "./assets/js/headerfooter-vanilla";

import "./assets/css/_global.less";
import "./assets/css/util.less";
import "./assets/css/spacing.less";
import "./assets/css/header.less";
import "./assets/css/footer.less";
import "./assets/css/superslides.css";



// WEBPACK FOOTER //
// ./src/app.js